// extracted by mini-css-extract-plugin
module.exports = {"container":"Checkbox_container__20jlM","checkmark":"Checkbox_checkmark__J3qaU"};